import React, {createElement, useEffect, useRef, useState} from 'react';
import Style from './index.module.scss';
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng/lowcode_tool/src/method/chip'
import Player from '@ifeng/three_terminal/es/pc/video/output/pcVideo.jsx';
import Chip from 'Chip';
import md5 from 'md5';

export interface Video_ip_Props {
    style?: object;

    headerStyle?: object
    headerImage?: string
    headerImageHeight?: number

    tabText1: string
    tabText2: string
    videoChip1: TYPE_Chip
    videoChip2: TYPE_Chip

    activeTabStyle?: object
    unActiveTabStyle?: object
    deviderColor?: string
    deviderMargin?: number

    videoWidth: number
    videoHeight: number
    videoAutoPlay: Boolean
    videoControls: Boolean
}

const Video_ip: React.FC<Video_ip_Props> = (props) => {
    const { videoChip1, videoChip2, style, headerStyle, headerImage, headerImageHeight, activeTabStyle,
        unActiveTabStyle, tabText1, tabText2, deviderColor, deviderMargin, videoWidth, videoHeight,
        videoAutoPlay, videoControls } = props;

    const [ tabIndex, setTabIndex ] = useState(0)
    const [ videoPlayIndex, setVideoPlayIndex ] = useState(0)
    const playIndexRef = useRef(0)

    const videoChipData1 = useChip(videoChip1);
    const videoChipData2 = useChip(videoChip2);



    const videoChipComponentData1 = formatChip(videoChip1)
    const videoChipComponentData2 = formatChip(videoChip2)

    const getHash = () => {
        return md5(JSON.stringify({ videoWidth, videoHeight, videoAutoPlay, videoControls, tabIndex }));
    }

    return (
        <div className={Style.wrap} style={style}>
            <div className={Style.header} style={{ ...headerStyle }}>
                <div>
                    {
                        headerImage && <img src={headerImage} style={{ marginLeft: '-20px', height: headerImageHeight }} alt="" />
                    }
                </div>
                <div className={Style.tabWp}>
                    <div className={Style.tab} style={tabIndex === 0 ? {...unActiveTabStyle, ...activeTabStyle} : unActiveTabStyle} onClick={() => setTabIndex(0)}>{tabText1}</div>
                    <div className={Style.divider} style={{ backgroundColor: deviderColor, margin: `0 ${deviderMargin}px` }} />
                    <div className={Style.tab} style={tabIndex === 1 ? {...unActiveTabStyle, ...activeTabStyle} : unActiveTabStyle} onClick={() => setTabIndex(1)}>{tabText2}</div>
                </div>
            </div>
            <div className={Style.videoPart}>
                <div style={{ width: videoWidth, height: videoHeight }}>
                    {
                        (tabIndex === 0 ? videoChipData1 : videoChipData2).length > 0 &&
                        <Player
                            key={getHash()}
                            videoConfig={(tabIndex === 0 ? videoChipData1 : videoChipData2).length > 0 ? (tabIndex === 0 ? videoChipData1 : videoChipData2) : [{ poster: '' }]}
                            playermsg={{
                                width: videoWidth,
                                height: videoHeight,
                                autoPlay: videoAutoPlay,
                                controls: videoControls,
                                playerHooks:({ changePlayIndex }) => {
                                    playIndexRef.current = changePlayIndex
                                },
                                playerEventTrigger: (player) => {
                                    player.on('ended', () => {
                                        if (videoPlayIndex < (tabIndex === 0 ? videoChipData1 : videoChipData2).length - 1) {
                                            setVideoPlayIndex(videoPlayIndex + 1)
                                            playIndexRef.current(videoPlayIndex + 1)
                                        }
                                    });
                                    player.on('canplay', () => {
                                        player.play();
                                    });
                                }
                            }}
                        />
                    }
                </div>
                <div className={Style.chipWp}>
                    <Chip {...videoChipComponentData1}><div className={Style.chip}/></Chip>
                    <Chip {...videoChipComponentData2}><div className={Style.chip}/></Chip>
                </div>

                <div className={Style.articleList} style={{ height: videoHeight }}>
                    {
                        (tabIndex === 0 ? videoChipData1 : videoChipData2).map((video, index) => {
                            return (
                                <div className={Style.article} key={index} onClick={() => playIndexRef.current(index)}>
                                    <img className={Style.img} src={video.posterUrl} alt="" />
                                    <div className={Style.title}>{video.title}</div>
                                </div>
                            )
                        })
                    }
                    <Mask visible={!(tabIndex === 0 ? videoChip1 : videoChip2).id} zIndex={3}>示例结构化碎片—{(tabIndex === 0 ? videoChip1 : videoChip2).default.id}</Mask>
                </div>
            </div>
        </div>
    );
};

export default Video_ip;
